import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/users";

export const getUsers = async (params = {}) => {
  return jeepRallyApi.get(baseUrl, { params });
};

export const getUsersByRole = async (role) => {
  return getUsers({ role });
};

export const createUser = async (userData) => {
  return jeepRallyApi.post(baseUrl, userData);
};
